export default __webpack_public_path__ + "static/section1-c3e30dcce98b8697ad9ca619f65c938a.webp";